"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _fullscreenItemPreload = _interopRequireDefault(require("./fullscreenItemPreload.js"));

var _utils = require("../utils/utils");

var _consts = _interopRequireDefault(require("@wix/photography-client-lib/dist/src/utils/consts"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var FullscreenImage =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(FullscreenImage, _React$Component);

  function FullscreenImage(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    if (typeof _this.props.actions.onItemCreated === 'function') {
      _this.props.actions.onItemCreated();
    }

    _this.onLoadImage = _this.onLoadImage.bind(_assertThisInitialized(_this));
    _this.state = {
      loaded: false,
      failed: false,
      retries: 1
    };
    return _this;
  }

  var _proto = FullscreenImage.prototype;

  _proto.onLoadImage = function onLoadImage() {
    this.setState({
      loaded: true
    });
  };

  _proto.getItemScaleByContainerSize = function getItemScaleByContainerSize(item, _ref) {
    var width = _ref.width,
        height = _ref.height;
    var ratio = width / height;
    var cutByWidth = ratio > item.ratio;
    var scaleHeight = item.height / height;
    var scaleWidth = item.width / width;
    return cutByWidth ? scaleHeight : scaleWidth;
  };

  _proto.getMediaUrl = function getMediaUrl() {
    var item = this.props.item;
    var url = !!this.props.isInSEO ? item.resized_url.seoLink : item.resized_url.img;
    return url;
  };

  _proto.onContextMenu = function onContextMenu(e) {
    if (!_utils.utils.isDev()) {
      e.preventDefault(e);
    }
  };

  _proto.render = function render() {
    var _this2 = this;

    var item = this.props.item;
    var size = {
      width: item.width + 'px',
      height: item.height + 'px'
    };
    var mobileZoomStyles = {};

    if (this.props.isZoom) {
      var isLandscape = window.orientation === 90 || window.orientation === -90;
      var screenHeight = window.screen.height;
      var screenWidth = window.screen.width;
      var ratio = screenWidth / screenHeight;
      var cutByHeight = ratio > item.ratio;

      if (isLandscape && _utils.utils.isiOS()) {
        cutByHeight = !cutByHeight;
      }

      size = cutByHeight ? {
        width: 'auto',
        height: '100%'
      } : {
        width: '100%',
        height: 'auto'
      };
      mobileZoomStyles = {
        transform: 'translate3d(-50%, -50%, 0)'
      };
    } // reverse transform of image, in mobile there is no transform


    var desktopPositionStyles = _utils.utils.isMobile() ? {} : {
      marginTop: '-' + Math.ceil(item.height / 2) + 'px',
      marginLeft: '-' + Math.ceil(item.width / 2) + 'px',
      transform: 'none'
    };

    var innerStyle = _objectSpread({
      objectFit: 'contain'
    }, desktopPositionStyles, {}, mobileZoomStyles, {}, size);

    if (this.props.isMobile) {
      innerStyle.outline = '1px solid transparent'; //hack for mobile, adds blur to make the picture look better
    }

    return !this.props.isDummy ? _react["default"].createElement("div", {
      onContextMenu: function onContextMenu(e) {
        return _this2.onContextMenu(e);
      }
    }, _react["default"].createElement(_fullscreenItemPreload["default"], {
      window: this.props.window,
      loaded: this.state.loaded,
      item: item,
      width: innerStyle.width,
      height: innerStyle.height,
      expandInfoPosition: this.props.expandInfoPosition
    }), _react["default"].createElement("img", {
      "data-hook": "fullscreen-image",
      className: 'fullscreen-content fullscreen-item pro-fullscreen-high-res ' + (this.state.loaded ? ' gallery-item-loaded ' : '') + (this.state.failed ? ' pro-fullscreen-error ' : ''),
      src: this.getMediaUrl(),
      alt: item.alt,
      onLoad: this.onLoadImage,
      key: 'image',
      style: innerStyle
    })) : _react["default"].createElement("div", null);
  };

  return FullscreenImage;
}(_react["default"].Component);

var _default = FullscreenImage;
exports["default"] = _default;